
function normalizeSortableText(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim()
    .toLocaleLowerCase("pt-BR");
}

export function compareAlpha(a, b) {
  return normalizeSortableText(a).localeCompare(normalizeSortableText(b), "pt-BR", { sensitivity: "base" });
}

export function sortAlpha(items = [], labelGetter = (item) => item?.label || item?.name || item) {
  return [...(Array.isArray(items) ? items : [])].sort((a, b) => compareAlpha(labelGetter(a), labelGetter(b)));
}

export function sortAlphaKeepingTodosFirst(items = [], labelGetter = (item) => item?.label || item?.name || item) {
  return [...(Array.isArray(items) ? items : [])].sort((a, b) => {
    const aLabel = String(labelGetter(a) || "").trim();
    const bLabel = String(labelGetter(b) || "").trim();
    const aTodos = normalizeSortableText(aLabel) === 'todos';
    const bTodos = normalizeSortableText(bLabel) === 'todos';
    if (aTodos && !bTodos) return -1;
    if (!aTodos && bTodos) return 1;
    return compareAlpha(aLabel, bLabel);
  });
}

function asTime(value) {
  const ts = Date.parse(String(value || ""));
  return Number.isFinite(ts) ? ts : 0;
}

function collectStatusChangeAt(record) {
  const direct = [
    record?.statusChangedAt,
    record?.statusUpdatedAt,
    record?.statusUpdated_at,
    record?.workflowUpdatedAt,
    record?.lastStatusChangeAt,
  ].map(asTime).filter(Boolean);

  const timelineTimes = (Array.isArray(record?.timeline) ? record.timeline : [])
    .filter(Boolean)
    .map((entry) => ({
      ts: asTime(entry?.ts || entry?.date || entry?.eventAt),
      text: normalizeSortableText(`${entry?.action || ''} ${entry?.status || ''} ${entry?.note || ''}`),
    }))
    .filter((entry) => entry.ts > 0 && /(status|paus|conclu|cancel|negad|aprova|execu|trânsito|transito|agend|retom|reinici)/.test(entry.text))
    .map((entry) => entry.ts);

  const workflowTimes = (Array.isArray(record?.workflowHistory) ? record.workflowHistory : [])
    .filter(Boolean)
    .map((entry) => asTime(entry?.ts || entry?.date || entry?.eventAt || entry?.updatedAt))
    .filter(Boolean);

  const all = [...direct, ...timelineTimes, ...workflowTimes];
  return all.length ? Math.max(...all) : 0;
}

function recordBaseTime(record) {
  return Math.max(
    asTime(record?.date),
    asTime(record?.dateStart),
    asTime(record?.reportedAt),
    asTime(record?.startedAt),
    asTime(record?.finishedAt),
    asTime(record?.createdAt),
    asTime(record?.updatedAt),
  );
}

export function compareOperationalRecords(a, b) {
  const aStatusTs = collectStatusChangeAt(a);
  const bStatusTs = collectStatusChangeAt(b);
  const aHasStatus = aStatusTs > 0;
  const bHasStatus = bStatusTs > 0;
  if (aHasStatus !== bHasStatus) return aHasStatus ? -1 : 1;
  if (aStatusTs !== bStatusTs) return bStatusTs - aStatusTs;
  const aBase = recordBaseTime(a);
  const bBase = recordBaseTime(b);
  if (aBase !== bBase) return bBase - aBase;
  return compareAlpha(a?.title || a?.name || a?.recordNumber || a?.id, b?.title || b?.name || b?.recordNumber || b?.id);
}
